(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  function loadBook2LookIframe(bibletId, container) {
    if (!bibletId) return;
    if (container.innerHTML.trim() !== '') return; // Prevent multiple iframe insertions

    const isMobile = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;

    // Create Book2Look iframe with proper parameters
    const currentHostname = window.location.hostname;
    const currentPath = window.location.pathname;
    const book2lookUrl = `https://www.book2look.com/embed/${bibletId}&euid=336527428&ruid=0&referurl=${currentHostname}&refererpath=${currentPath}&bibletType=double`;

    container.innerHTML = `<iframe align="middle" frameborder="0" width="100%" height="${isMobile ? '500' : '752'}" src="${book2lookUrl}"></iframe>`;
  }

  document.addEventListener('DOMContentLoaded', function () {
    const bibletContainers = document.querySelectorAll('.biblet-container');

    for (const container of bibletContainers) {
      const details = container.closest('details');
      const button = container.parentElement.parentElement.querySelector('[data-leseprobe-button]');

      details?.addEventListener('toggle', function () {
        if (details.open === false) return; // Only load when opened

        const bibletId = container.getAttribute('data-biblet-id');
        loadBook2LookIframe(bibletId, container);
      });

      button?.addEventListener('click', function () {
        const bibletId = container.getAttribute('data-biblet-id');
        loadBook2LookIframe(bibletId, container);
      });
    }

    function displayJudgeMeWidgets() {
      const widgets = document.querySelectorAll('.jdgm-legacy-widget-content');
      widgets.forEach((widget) => {
        widget.style.display = '';
      });
    }

    const intervalId = setInterval(() => {
      displayJudgeMeWidgets();
    }, 500);

    setTimeout(() => {
      clearInterval(intervalId);
    }, 7000);
  });

  } catch(e) { console.error(e); }
})();
})();
